import UnderLyingEnum from '@/@enums/UnderLyingEnum';
import {
  ActivityChannelIdEnum,
  ActivityChannelIdEnumQa,
  ActivityIdEnum,
  ActivityIdEnumQa,
  TaskTypeEnum,
} from '@/@enums/Activity';
import { getOrigin } from '@/utils/location';

export const POSITION_TYPE_TEXT_MAP: { [key in PositionType]: string } = {
  ISOLATED: 'placeholder.isolated',
  CROSSED: 'placeholder.crossed',
};
export const POSITION_MODE_TEXT_MAP: { [key in PositionMode]: string } = {
  AGGREGATION: 'placeholder.aggregation',
  DISAGGREGATION: 'placeholder.disaggregation',
};

export const POSITION_SIDE_TEXT_MAP: { [key in PositionSide]: string } = {
  LONG: 'placeholder.long',
  SHORT: 'placeholder.short',
};

export const getPositionSizeText = (positionSide: PositionSide) => POSITION_SIDE_TEXT_MAP[positionSide] || '';

// order

export const ORDER_UNCOMPLETED_STATE_LIST: OrderState[] = ['NEW', 'PARTIALLY_FILLED'];

export const ORDER_SIDE_TEXT_MAP = {
  BUY_LONG: 'placeholder.buyLong',
  BUY_SHORT: 'placeholder.buyShort',
  SELL_LONG: 'placeholder.sellLong',
  SELL_SHORT: 'placeholder.sellShort',
  BUY: 'btn.buy',
  SELL: 'btn.sell',
};
export const ORDER_TYPE_TEXT_MAP = {
  LIMIT: 'market.orderForm.entrust.limit',
  MARKET: 'market.orderForm.entrust.market',
};
export const getOrderTypeText = (orderType: OrderType | string) => {
  return ORDER_TYPE_TEXT_MAP[orderType as OrderType] || '';
};

export const getOrderSideText = (orderSide: OrderSide, positionSide?: PositionSide) => {
  if (positionSide) {
    // @ts-ignore
    return ORDER_SIDE_TEXT_MAP[`${orderSide}_${positionSide}`] || '';
  }
  // @ts-ignore
  return ORDER_SIDE_TEXT_MAP[`${orderSide}`] || '';
};

// 合约订单菜单界面使用
export const RECORD_SIDE_TEXT_MAP = {
  BUY_LONG: 'btn.buyLong',
  BUY_SHORT: 'btn.buyShort',
  SELL_LONG: 'btn.sellLong',
  SELL_SHORT: 'btn.sellShort',
  BUY: 'btn.buy',
  SELL: 'btn.sell',
};

// eslint-disable-next-line consistent-return
export const getRecordSideText = (orderSide: OrderSide, positionSide?: PositionSide) => {
  if (positionSide) {
    // @ts-ignore
    return RECORD_SIDE_TEXT_MAP[`${orderSide}_${positionSide}`] || '';
  }
  // @ts-ignore
  return RECORD_SIDE_TEXT_MAP[`${orderSide}`] || '';
};

// orderBill

export const ENTRUST_STOP_TYPE_LIST: EntrustType[] = [
  'TAKE_PROFIT',
  'STOP',
  'TAKE_PROFIT_MARKET',
  'STOP_MARKET',
  'TRAILING_STOP_MARKET',
];

export const PLAN_UNCOMPLETED_STATE_LIST: EntrustState[] = ['NOT_TRIGGERED', 'TRIGGERING'];

export const getTaskTypeText = (type: TaskTypeEnum): { title: string; desc: string } => {
  switch (type) {
    case TaskTypeEnum.INVITED_AND_REGISTER:
      return {
        title: 'activity.task.invitedAndRegister.title',
        desc: 'activity.task.invitedAndRegister.desc',
      };
    case TaskTypeEnum.INVITED_AND_KYC_SUPERPOSITION:
      return {
        title: 'activity.task.invitedAndKycSuperposition.title',
        desc: 'activity.task.invitedAndKycSuperposition.desc',
      };
    case TaskTypeEnum.THANOS_TRADE:
      return {
        title: 'activity.task.thanosTrade.title',
        desc: 'activity.task.thanosTrade.desc',
      };
    case TaskTypeEnum.NEW_FIRST_RECHARGE:
      return {
        title: 'activity.task.newFirstRecharge.title',
        desc: 'activity.task.newFirstRecharge.desc',
      };
    case TaskTypeEnum.GENERAL_INVITE:
      return {
        title: 'activity.task.generalInvite.title',
        desc: 'activity.task.generalInvite.desc',
      };
    case TaskTypeEnum.SHARE_LINK:
      return {
        title: 'activity.task.shareLink.title',
        desc: 'activity.task.shareLink.desc',
      };
    case TaskTypeEnum.TRANSFER_TO_THANOS:
      return {
        title: 'activity.task.transferToThanos.title',
        desc: 'activity.task.transferToThanos.desc',
      };
    case TaskTypeEnum.TRADE_AMOUNT_SUM:
      return {
        title: 'activity.task.tradeAmountSum.title',
        desc: 'activity.task.tradeAmountSum.desc',
      };
    case TaskTypeEnum.PLAY_NEW_FUNCTION:
      return {
        title: 'activity.task.playNewFunction.title',
        desc: 'activity.task.playNewFunction.desc',
      };
    case TaskTypeEnum.BOND:
      return {
        title: 'activity.task.bond.title',
        desc: 'activity.task.bond.desc',
      };
    case TaskTypeEnum.TURNTABLE_LOTTERY:
      return {
        title: 'activity.task.turntableLottery.title',
        desc: 'activity.task.turntableLottery.desc',
      };
    default:
      return { title: '', desc: '' };
  }
};

export const REWARD_TYPE_TEXT = {
  CASH_BACK: 'activity.cashback',
  BONUS: 'activity.bonus',
};

export const GUIDE_LANG_MAP = {
  ko: 'ko-kr',
  ja: 'ja',
  ru: 'ru',
  hk: 'zh-tw',
  zh: 'zh-cn',
  en: 'en-us',
};

export const getCoinFromSymbol = (symbol: string): string => {
  const coin = symbol.split('_')[0];
  return coin?.toUpperCase() || '';
};

// 项目仅支持 U 本位，合约接口统一走 /f
export const getBaseUrlBySymbol = (_symbol?: string): string => '/f';

export const getBaseUrlByUnderlyingType = (_underlyingType?: UnderLyingEnum): string => '/f';

export const getPriceUnit = (underlyingType: UnderLyingEnum) =>
  underlyingType === UnderLyingEnum.U_BASED ? 'USDT' : 'USD';

export const getActivityIdByEnv = () => {
  const regex = /xt-qa/g;
  const isQa = !!getOrigin().match(regex);

  return isQa ? ActivityIdEnumQa.SUMMER : ActivityIdEnum.SUMMER;
};

export const getActivityChannelIdByEnv = () => {
  const regex = /xt-qa/g;
  const isQa = !!getOrigin().match(regex);

  return isQa ? ActivityChannelIdEnumQa.SUMMER : ActivityChannelIdEnum.SUMMER;
};

export const getActivityBaseUrl = () => {
  const regex = /xt-qa/g;
  const isQa = !!getOrigin().match(regex);

  return isQa ? 'http://futures.xt-qa.com' : 'https://futures.hextest.net';
};
